var _path, _rect, _path2, _rect2, _rect3, _path3, _rect4, _rect5, _path4, _rect6, _rect7, _rect8, _rect9, _path5, _rect10, _rect11, _rect12, _rect13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTable = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 24,
  viewBox: "0 0 26 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M8 1H1v6h7V1zM7 6H2V2h5v4z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 3,
  x: 9,
  y: 8,
  fill: "none"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M14 7V1H9v6h5zm-4-5h3v4h-3V2z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 3,
  x: 9,
  y: 12,
  fill: "none"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 3,
  x: 15,
  y: 12,
  fill: "none"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M20 7V1h-5v6h5zm-4-5h3v4h-3V2z"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 3,
  x: 15,
  y: 8,
  fill: "none"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 7,
  height: 3,
  x: 1,
  y: 8,
  fill: "none"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M21 1v6h5v1h-5v3h5v1h-5v3h5v1h-5v3h5V1h-5zm4 5h-3V2h3v4z"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 3,
  x: 9,
  y: 16,
  fill: "none"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 3,
  x: 15,
  y: 16,
  fill: "none"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 7,
  height: 3,
  x: 1,
  y: 12,
  fill: "none"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  width: 7,
  height: 3,
  x: 1,
  y: 16,
  fill: "none"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M26 0H1C.4 0 0 .4 0 1v18c0 .6.4 1 1 1h25c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-6 1v6h-5V1h5zm-5 7h5v3h-5V8zm0 4h5v3h-5v-3zM14 1v6H9V1h5zM9 8h5v3H9V8zm0 4h5v3H9v-3zM1 1h7v6H1V1zm0 7h7v3H1V8zm0 4h7v3H1v-3zm0 7v-3h7v3H1zm8 0v-3h5v3H9zm6 0v-3h5v3h-5zm11 0h-5v-3h5v-1h-5v-3h5v-1h-5V8h5V7h-5V1h5v18z"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 4,
  x: 22,
  y: 2
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 4,
  x: 16,
  y: 2
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 4,
  x: 10,
  y: 2
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 4,
  x: 2,
  y: 2
})));
export default SvgIconTable;